import React from 'react';
import styled, { keyframes } from 'styled-components';

import Block from 'src/components/UI/elements/Block';

const shimmer = keyframes`
    0% {
        opacity: 0.6;
    }
    50% {
        opacity: 0.8;
    }
    100% {
        opacity: 0.6;
    }
`;

const SkeletonBlock = styled(Block)`
    opacity: 0.8;
    animation: ${shimmer} 1.5s ease-in-out infinite;
    pointer-events: none;
    
    &::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(255, 255, 255, 0.05) 50%,
            transparent 100%
        );
        animation: ${shimmer} 1.5s ease-in-out infinite;
    }
`;

const SkeletonContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    height: 100%;
`;

const SkeletonHeader = styled.div`
    height: 20px;
    background-color: #454650;
    border-radius: 4px;
    width: 60%;
`;

const SkeletonLine = styled.div<{ $width?: string; $height?: string }>`
    height: ${props => props.$height || '12px'};
    background-color: #454650;
    border-radius: 4px;
    width: ${props => props.$width || '100%'};
    margin-bottom: 8px;
`;

const SkeletonGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    margin-top: 8px;
`;

interface BlockSkeletonProps {
    style?: React.CSSProperties;
    className?: string;
    lines?: number;
    showGrid?: boolean;
}

const BlockSkeleton: React.FC<BlockSkeletonProps> = ({ 
    style, 
    className, 
    lines = 5,
    showGrid = false 
}) => {
    return (
        <SkeletonBlock style={style} className={className} expandPadding={true}>
            <SkeletonContent>
                <SkeletonHeader />
                {Array.from({ length: lines }).map((_, index) => (
                    <SkeletonLine 
                        key={`line-${index}`}
                        $width={index % 2 === 0 ? '100%' : '80%'}
                        $height={index === 0 ? '16px' : '12px'}
                    />
                ))}
                {showGrid && (
                    <SkeletonGrid>
                        <SkeletonLine $height="40px" />
                        <SkeletonLine $height="40px" />
                    </SkeletonGrid>
                )}
            </SkeletonContent>
        </SkeletonBlock>
    );
};

export default BlockSkeleton;

















